import { z } from 'zod';
import { pointSchema } from './pointSchema';

export const panelLineStateSchema = z.object({
  id: z.string(),
  point1: pointSchema,
  point2: pointSchema,
  hiddenPanels: z.array(z.number()),
  orientation: z.enum(['vertical', 'horizontal']).optional(),

  // store
  angle: z.number().optional(),
  panelAmount: z.number().optional(),
});

export type PanelLineState = z.infer<typeof panelLineStateSchema>;
